import {
  PERSON_FIELDS_TO_SEND,
  DOCUMENT_FIELDS_TO_SEND,
  MARRIAGE_FIELDS_TO_SEND,
} from './fieldNamesToSend';
import {
  CHANGE_NAME_DOC_ISSUER,
  DOCUMENT_FIELD_NAME,
  MARRIAGE_INFO_FIELD_NAME,
  PERSON_FIELD_NAME,
} from './fieldNames';
import { ADDRESS_INFO_FIELD_NAME } from './address';

export const PERSON_FIELDS_FROM_DRAFT = {
  [PERSON_FIELDS_TO_SEND.name]: PERSON_FIELD_NAME.name,
  [PERSON_FIELDS_TO_SEND.surname]: PERSON_FIELD_NAME.surname,
  [PERSON_FIELDS_TO_SEND.patronymic]: PERSON_FIELD_NAME.patronymic,
  [PERSON_FIELDS_TO_SEND.isPatronymicAbsent]:
    PERSON_FIELD_NAME.isPatronymicAbsent,
  [PERSON_FIELDS_TO_SEND.sex]: PERSON_FIELD_NAME.sex,
  [PERSON_FIELDS_TO_SEND.birthdate]: PERSON_FIELD_NAME.birthdate,
  [PERSON_FIELDS_TO_SEND.changeName]: PERSON_FIELD_NAME.changeName,
  [PERSON_FIELDS_TO_SEND.changeNameDocIssuer]: CHANGE_NAME_DOC_ISSUER,
  [PERSON_FIELDS_TO_SEND.isRegisteredInMoscow]: 'isRegisteredInMoscow',
};

export const ADDRESS_FIELDS_FROM_DRAFT = {
  ...ADDRESS_INFO_FIELD_NAME,
  is_manual_input: 'isManualInput',
  bti_building_code: 'bti_building_code',
  is_serve_by_eirc: 'isServeByEirc',
};

export const DOCUMENT_FIELDS_FROM_DRAFT = {
  [DOCUMENT_FIELDS_TO_SEND.type]: DOCUMENT_FIELD_NAME.type,
  [DOCUMENT_FIELDS_TO_SEND.number]: DOCUMENT_FIELD_NAME.number,
  [DOCUMENT_FIELDS_TO_SEND.issuer]: DOCUMENT_FIELD_NAME.issuer,
  [DOCUMENT_FIELDS_TO_SEND.issueDate]: DOCUMENT_FIELD_NAME.issueDate,
  [DOCUMENT_FIELDS_TO_SEND.divisionCode]: DOCUMENT_FIELD_NAME.divisionCode,
};

export const MARRIAGE_FIELDS_FROM_DRAFT = {
  [MARRIAGE_FIELDS_TO_SEND.dateOfMarriage]:
    MARRIAGE_INFO_FIELD_NAME.dateOfMarriage,
  [MARRIAGE_FIELDS_TO_SEND.marriageRecordHolder]:
    MARRIAGE_INFO_FIELD_NAME.marriageRecordHolder,
  [MARRIAGE_FIELDS_TO_SEND.marriageRecordNumber]:
    MARRIAGE_INFO_FIELD_NAME.marriageRecordNumber,
};
